export const TRANSLATION_PREFIX = 'STATIC.TOPBAR_HEADERS.ASK_SINGULAR_AI';
export const ANALYSIS_CHAT_HASH = '#/react/analysis-chat';
export const MIXPANEL_PREFIX = 'Quick Agent';
export const STARTING_DELAY_MS = 650;
